import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
    NgbDateAdapter,
    NgbDateParserFormatter,
    NgbDatepickerModule,
    NgbDropdownModule,
    NgbCollapseModule,
} from '@ng-bootstrap/ng-bootstrap';

import { MatSelectModule } from '@angular/material/select';
import { ComponentsModule } from '@ed---interne/ng-uui-components';

import { EdDatepickerComponent } from './components/forms/ed-datepicker/ed-datepicker.component';
import {
    CustomAdapter,
    CustomDateParserFormatter,
} from './components/forms/ed-datepicker/ngbd-datepicker.adapter';
import { EdInputFileComponent } from './components/forms/ed-input-file/ed-input-file.component';
import { EdCardComponent } from './components/ed-card/ed-card.component';
import { DropZoneDirective } from './components/forms/ed-input-file/dropzone.directive';
import { InfiniteScrollDirective } from './directives/infinite-scroll.directive';

@NgModule({
    declarations: [EdDatepickerComponent, EdInputFileComponent, EdCardComponent, DropZoneDirective],
    imports: [
        CommonModule,
        FormsModule,
        NgbDatepickerModule,
        NgbDropdownModule,
        NgbCollapseModule,
        ComponentsModule,
        InfiniteScrollDirective,
        MatSelectModule,
    ],
    exports: [
        EdDatepickerComponent,
        EdInputFileComponent,
        EdCardComponent,
        DropZoneDirective,
        InfiniteScrollDirective,
    ],
    providers: [
        { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    ],
})
export class SharedModule {}
